import i18n from "i18next"
import { initReactI18next } from "react-i18next"
// import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from "i18next-http-backend"
// import { config } from './config'

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)

  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)

  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options

  .init({
    debug: false,
    fallbackLng: "es",
    backend: {
      loadPath: () => {
        const url = window.location.href
        const k = "/inco/proyectos/cinacina"
        const isFingLike = url.includes(k)
        if (isFingLike)
          return "/inco/proyectos/cinacina/locales/{{lng}}/{{ns}}.json"
        return "/locales/{{lng}}/{{ns}}.json"
      },
      allowMultiLoading: false,
      crossDomain: false,
    },
    load: "languageOnly",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

export default i18n
